import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, Label, Form, Alert, Input, FormFeedback } from 'reactstrap';
import logoDark2 from "../../assets/images/logo-dark.png"

import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import PropTypes from "prop-types";

import { apiRequest } from "../../components/Common/ApiManagement/apiCall"
import { ApiNames } from '../../components/Common/ApiManagement/apiServices';

import { handleErrors, showToaster } from '../../components/Common/common';


// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import withRouter from 'components/Common/withRouter';

import { Link, useNavigate } from "react-router-dom"


// actions
import { getUser, socialLogin } from "../../store/actions";
import axiosInstance from 'components/Common/ApiManagement/axiosInstance';
import { PAGEPATHS, USERTYPES } from 'components/Common/Constant';

import GoogleLogin from './GoogleLogin';

const Login = props => {
  document.title = "Login | Lexa - Responsive Bootstrap 5 Admin Dashboard";

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  // const user = useSelector((state) => state?.users.users)

  // useEffect(() => {
  //   console.log('USER-REDUX:', user);
  //   if (user && Object.keys(user).length > 0)
  //     navigate(PAGEPATHS.Scanlist)
  // }, [user])

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      handleSubmit(values);
    }
  })

  const handleSubmit = async (values) => {
    const postForm = {
      email: values.email,
      password: values.password,
      rememberMe
    }

    try {
      const { data } = await axiosInstance.post(ApiNames.USER_SIGNIN, postForm);
      if (data.status === 1) {
        if (data.data) dispatch(getUser(data.data))
        showToaster(data.status, data.message);
        // data.data.userType === USERTYPES.Admin
        //   ? navigate(PAGEPATHS.Scanlist)
        //   : navigate(PAGEPATHS.Addsiteurl)

        navigate(PAGEPATHS.Scanlist)

      } else {
        showToaster(data.status, data.message);
      }
    } catch (error) {
      handleErrors(error)
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="account-pages pt-7 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5} className='px-4'>
              <Card className="overflow-hidden">
                <CardBody className="pt-0">

                  <h3 className="text-center mt-5 mb-4">
                    <Link to="/" className="d-block auth-logo">
                      <img src={logoDark2} alt="" height="30" className="auth-logo-dark" />
                      <img src={logoDark2} alt="" height="30" className="auth-logo-light" />
                    </Link>
                  </h3>

                  <div className="px-0 md:px-3 p-3">
                    <h4 className="text-muted font-size-18 mb-1 text-center">Welcome Back !</h4>
                    <Form
                      className="form-horizontal mt-4"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();

                      }}
                    >
                      <div className="mb-3">
                        <Label htmlFor="email">Email</Label>
                        <Input
                          name="email"
                          className="form-control py-2"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <div className='d-flex justify-content-between'>
                          <Label htmlFor="userpassword">Password</Label>
                        </div>
                        <Input
                          name="password"
                          value={validation.values.password || ""}
                          className='form-control py-2'
                          type="password"
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.password && validation.errors.password ? true : false
                          }
                        />
                        {validation.touched.password && validation.errors.password ? (
                          <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                        ) : null}
                      </div>
                      <Row className="mb-3 mt-4 align-items-center justify-content-between">
                        <div className="col-6 d-flex align-items-center gap-2 text-start">
                          <input
                            type="checkbox" className='pe-auto btn border h-6'
                            style={{ height: "1.5rem" }}
                            onChange={(e) => setRememberMe(e.target.checked)}
                          />
                          <p className="mb-0">
                            Remember Me
                          </p>
                        </div>
                        <div className="col-6 text-end">
                          <p className="mb-0">
                            <Link to={PAGEPATHS.Forget} className="">
                              Forget password?
                            </Link>
                          </p>
                        </div>
                      </Row>
                      <div className="col-6 d-flex w-100 align-items-center justify-content-center">
                        <button
                          className="btn text-center py-2 btn-primary w-md waves-effect waves-light"
                          type="submit"
                        >
                          Log In
                        </button>
                      </div>
                    </Form>
                  </div>
                  <GoogleLogin />
                  <div className="col-6 mt-4 text-center w-100">
                    <p className="mb-0">
                      New Here ?{" "}
                      <Link to="/register" className="">
                        {" "}
                        Create Account{" "}
                      </Link>
                    </p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

    </React.Fragment>
  )
}

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
